import type { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function whitespaceValidator(): ValidatorFn {
  return (control: AbstractControl<string>): ValidationErrors | null => {
    const value = control.value ?? '';

    return value && !value.trim() ? { onlyWhitespace: true } : null;
  };
}
